import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/k2/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { k2BaseQuery } from './baseQuery';

const FIVE_MINUTES = 5 * 60;

export const K2_API_REDUCER_PATH = 'api/k2' as const;

export const k2ApiRoot = createApi({
  reducerPath: K2_API_REDUCER_PATH,
  baseQuery: k2BaseQuery,
  keepUnusedDataFor: FIVE_MINUTES,
  refetchOnFocus: false,
  // Covers browser offline → online only. Pusher can also drop while the browser
  // stays online, which this does not cover — that gap is closed by the
  // `state_change` resync in ~/common/contexts/pusherStore.
  refetchOnReconnect: true,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
